import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();
  if (!value) {
    return '';
  }
  const { sales_order, signed_sales_order, salesperson } = value;
  let icon = cygnusSpriteHtml('warning', { variant: 'solid', className: 'text-warning', title: 'Awaiting Invoice' });

  if (!sales_order && !signed_sales_order) {
    icon = cygnusSpriteHtml('x-circle', { variant: 'solid', className: 'text-danger' });
  } else if (signed_sales_order) {
    icon = cygnusSpriteHtml('check-circle', { variant: 'solid', className: 'text-success' })
  }

  const el = document.createElement('div');
  el.classList.add('d-flex', 'flex-column', 'align-items-center');

  let html = `<div>${icon}</div>`;
  if (salesperson) {
    html += `<div>${salesperson}</div>`;
  }

  el.innerHTML = html;
  return el;
}
